import en from "./en/en";
import es from "./es/es";
import es_caixabank from "./es/es_caixabank";
import es_cochesnet from "./es/es_cochesnet";
import es_default_by_merchant from "./byMerchantFlow/es_default_by_merchant";
import { ONBOARDING_FULFILLED_BY_TYPES } from "../../components/shared/config";
import en_caixabank from "./en/en_caixabank";
import en_cochesnet from "./en/en_cochesnet";
import en_default_by_merchant from "./byMerchantFlow/en_default_by_merchant";
import ca from "./ca/ca";
import ca_caixabank from "./ca/ca_caixabank";
import ca_cochesnet from "./ca/ca_cochesnet";
import ca_default_by_merchant from "./byMerchantFlow/ca_default_by_merchant";
import es_upf from "./es/es_upf";
import ca_upf from "./ca/ca_upf";
import en_upf from "./en/en_upf";
import { CustomRegistry } from "@nemuru-eng/js-api-client";
import en_astara from "./en/en_astara";
import es_astara from "./es/es_astara";
import ca_astara from "./ca/ca_astara";
import es_vaillant from "./es/es_vaillant";
import en_vaillant from "./en/en_vaillant";
import ca_vaillant from "./ca/ca_vaillant";

export const LANGUAGES = {
  spanish: "es",
  catalan: "ca",
  english: "en",
};

export const CONTACT_INFO_BY_REGISTRY = {
  [CustomRegistry.DEFAULT]: {
    phone: "+34 932 200 612",
    email: "info@nemuru.com",
  },
  [CustomRegistry.CAIXABANK]: {
    phone: "+34 933 203 363",
    email: "mifinanciacion@caixabankpc.com",
  },
  [CustomRegistry.FACILITEA]: {
    phone: "+34 933 203 363",
    email: "mifinanciacion@caixabankpc.com",
  },
  [CustomRegistry.TESLA]: {
    phone: "+34 933 203 363",
    email: "mifinanciacion@caixabankpc.com",
  },
};

export const defaultLang = LANGUAGES.spanish;
export const defaultRegistry = CustomRegistry.DEFAULT;
export const defaultOnBoardingBy = ONBOARDING_FULFILLED_BY_TYPES.BORROWER_POS;

export const dictionaryList = {
  en: {
    default: {
      root: { ...en },
      overrides: {
        merchant_pos: { ...en_default_by_merchant },
      },
    },
    [CustomRegistry.CAIXABANK]: {
      root: {
        ...en,
        ...en_caixabank,
      },
    },
    [CustomRegistry.FACILITEA]: {
      root: {
        ...en,
        ...en_caixabank,
      },
    },
    [CustomRegistry.TESLA]: {
      root: {
        ...en,
        ...en_caixabank,
      },
    },
    [CustomRegistry.COCHESNET]: {
      root: { ...en, ...en_cochesnet },
    },
    [CustomRegistry.UPF]: { root: { ...en, ...en_upf } },
    [CustomRegistry.ASTARA]: { root: { ...en, ...en_astara } },
    [CustomRegistry.VAILLANT]: { root: { ...en, ...en_vaillant } },
    [CustomRegistry.TECHNOLOGICAL_PLATFORM]: { root: { ...en } },
  },
  es: {
    default: {
      root: { ...es },
      overrides: {
        merchant_pos: { ...es_default_by_merchant },
      },
    },
    [CustomRegistry.CAIXABANK]: {
      root: {
        ...es,
        ...es_caixabank,
      },
    },
    [CustomRegistry.FACILITEA]: {
      root: {
        ...es,
        ...es_caixabank,
      },
    },
    [CustomRegistry.TESLA]: {
      root: {
        ...es,
        ...es_caixabank,
      },
    },
    [CustomRegistry.COCHESNET]: {
      root: { ...es, ...es_cochesnet },
    },
    [CustomRegistry.UPF]: { root: { ...es, ...es_upf } },
    [CustomRegistry.ASTARA]: { root: { ...es, ...es_astara } },
    [CustomRegistry.VAILLANT]: { root: { ...es, ...es_vaillant } },
    [CustomRegistry.TECHNOLOGICAL_PLATFORM]: {
      root: { ...es },
    },
  },
  ca: {
    [CustomRegistry.DEFAULT]: {
      root: { ...ca },
      overrides: {
        merchant_pos: { ...ca_default_by_merchant },
      },
    },
    [CustomRegistry.CAIXABANK]: {
      root: {
        ...ca,
        ...ca_caixabank,
      },
    },
    [CustomRegistry.FACILITEA]: {
      root: {
        ...ca,
        ...ca_caixabank,
      },
    },
    [CustomRegistry.TESLA]: {
      root: {
        ...ca,
        ...ca_caixabank,
      },
    },
    [CustomRegistry.COCHESNET]: {
      root: { ...ca, ...ca_cochesnet },
    },
    [CustomRegistry.UPF]: { root: { ...ca, ...ca_upf } },
    [CustomRegistry.ASTARA]: { root: { ...ca, ...ca_astara } },
    [CustomRegistry.VAILLANT]: { root: { ...ca, ...ca_vaillant } },
    [CustomRegistry.TECHNOLOGICAL_PLATFORM]: {
      root: { ...ca },
    },
  },
};

export const CONDITIONAL_COMPONENTS_IDS = {
  // NEW_PLATFORM_DOC_BUTTON_NEMURU: "NEW_PLATFORM_DOC_BUTTON_NEMURU",
  // FORMATION_MENU: "FORMATION_MENU",
};

export const ALLOWED_COMPONENTS_FOR_REGISTRY = {
  [CustomRegistry.DEFAULT]: [
    // CONDITIONAL_COMPONENTS_IDS.NEW_PLATFORM_DOC_BUTTON_NEMURU,
    // CONDITIONAL_COMPONENTS_IDS.FORMATION_MENU,
  ],
  [CustomRegistry.CAIXABANK]: [
    // CONDITIONAL_COMPONENTS_IDS.NEW_PLATFORM_DOC_BUTTON_NEMURU,
    // CONDITIONAL_COMPONENTS_IDS.FORMATION_MENU,
  ],
};
